"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowALeftIcon16Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowALeftIcon16Regular = forwardRef_1.forwardRef('ArrowALeftIcon16Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { d: "M7.574 12.392a.75.75 0 1 1-1.06 1.06L2.585 9.525a2.156 2.156 0 0 1 0-3.05l3.927-3.927a.75.75 0 1 1 1.06 1.06L3.934 7.25h9.352a.75.75 0 0 1 0 1.5H3.932l3.642 3.642Z" })));
});
